module.exports = __webpack_public_path__ + "static/image-desktop-tech-49ea4fdf9c30fb9ceff7904d37ca4d1d.png";